import { render, staticRenderFns } from "./WebContentEdit.vue?vue&type=template&id=00621c85&"
import script from "./WebContentEdit.vue?vue&type=script&lang=js&"
export * from "./WebContentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports